module.exports = {
  convertDataToCSV: (grid, columns) => {
    return [columns]
      .concat(grid)
      .map(row => row.join(','))
      .join('\n');
  },
};
